import script from "./Team.vue?vue&type=script&setup=true&lang=js"
export * from "./Team.vue?vue&type=script&setup=true&lang=js"

import "./Team.vue?vue&type=style&index=0&id=4b1e533a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b1e533a"]])

export default __exports__